<template>
  <section role="main" class="content-body">
    <header class="page-header">
      <h2>基本兵役資料</h2>
      <div class="right-wrapper">
        <ol class="breadcrumbs">
          <li>
            <a href="/">
              <i class="fa fa-home"></i>
            </a>
          </li>
          <li><span>基本兵役資料</span></li>
        </ol>
      </div>
    </header>
    <!-- start: page -->
    <div id="tabs-01" class="row">
      <div class="col-md-13">
        <form id="form" action="forms-validation.html" class="form-horizontal">
          <section class="panel">
            <header class="panel-heading">
              <h2 class="panel-title">基本兵役資料</h2>
            </header>
            <div class="panel-body" align="right">
              <div align="left">
                學　　制：
                <select v-model="search.educateSystem">
                  <option value="">請選擇</option>
                  <option v-for="(item, index) in educateSystemList" :key="index" :value="item.code">{{item.value}}</option>
                </select>　
                科　　系：
                <select v-model="search.dept">
                  <option value="">請選擇</option>
                  <option v-for="(item, index) in deptList" :key="index" :value="item.code">{{item.value}}</option>
                </select>　
                年　　級：
                <select v-model="search.drade">
                  <option value="">請選擇</option>
                  <option value="1">一年級</option>
                  <option value="2">二年級</option>
                  <option value="3">三年級</option>
                  <option value="4">四年級</option>
                </select>　
                學　　號：<input type="text" v-model="search.studentId" style="width: 100px;" />　
                　<br />
                縣　　市：
                <select v-model="search.cityId" @change="cityChange">
                  <option :value="null">請選擇</option>
                  <option v-for="(item, index) in cityList" :key="index" :value="item.value">{{item.text}}</option>
                </select>　
                鄉鎮區村里：
                <select v-model="search.areaId">
                  <option value="">請選擇</option>
                  <option v-for="(item, index) in areaList" :key="index" :value="item.value">{{item.text}}</option>
                </select>　
                姓　　名：<input type="text" v-model="search.studentName" style="width: 100px;" />　
                身分證字號：<input type="text" v-model="search.idno" style="width: 100px;" />
                　<br />
                入學日期：<input type="text" v-model="search.entryYM" style="width: 100px;" />　
                在學狀態：
                <select v-model="search.state">
                  <option value="">請選擇</option>
                  <option v-for="(item, index) in stuStateList" :key="index" :value="item.code">{{item.value}}</option>
                </select>
                <select v-model="search.restOrOutType">
                  <option value="">請選擇</option>
                  <option value="復學">復學</option>
                  <option value="轉入">轉入</option>
                </select>　
                <br/>
                <label>離校日期(起)：</label>
                <datepicker :format="customFormatter" :language="zh" v-model="search.restOrOutDateBegin" style="display: inline-block;" />
                <label>~離校日期(迄)：</label>
                <datepicker :format="customFormatter" :language="zh" v-model="search.restOrOutDateEnd" style="display: inline-block;" />
                　<br />
                兵役狀態：
                <select v-model="search.status">
                  <option value="">請選擇</option>
                  <option value="已役">已役</option>
                  <option value="未役">未役</option>
                  <option value="其他">其他</option>
                  <option value="未填">未填</option>
                </select>　　
                申請項目：
                <select v-model="search.applyItem">
                  <option value="">請選擇</option>
                  <option value="緩徵申請">緩徵申請</option>
                  <option value="緩徵延長修業">緩徵延長修業</option>
                  <option value="緩徵消滅">緩徵消滅</option>
                  <option value="儘後召集申請">儘後召集申請</option>
                  <option value="儘後召集延長修業">儘後召集延長修業</option>
                  <option value="儘後召集消滅">儘後召集消滅</option>
                </select>　
                狀態：
                <select v-model="search.applyStatus">
                  <option value="">請選擇</option>
                  <option value="已申請">已申請</option>
                  <option value="未申請">未申請</option>
                </select>　
                審核狀態：
                <select v-model="search.adminCheck">
                  <option value="">請選擇</option>
                  <option :value="'Y'">審核通過</option>
                  <option :value="'F'">審核不通過</option>
                  <option :value="'N'">未審核</option>
                </select>
                <br><br>
                <div align="center">
                  <a href="#" @click.prevent="searchSubmit" class="btn-upload btn btn-primary" style="background-color:#337AB7; border-color:#2E6DA4;">查詢</a>　
                  <a href="#" @click.prevent="searchClear" class="btn-upload btn btn-primary" style="background-color:#666; border-color:#666;">清空</a>
                  <a href="#" @click.prevent="searchExport" class="btn-upload btn btn-primary" style="background-color:#ED9C28; border-color:#ED9C28;" align="right">匯出資料</a>　
                </div>
              </div>
            </div>
          </section>
        </form>
      </div>
    </div>
    <div id="tabs-02" class="row">
      <div class="col-md-13">
        <form id="form" action="forms-validation.html" class="form-horizontal">
          <section class="panel">
            <header class="panel-heading">
              <h2 class="panel-title">基本兵役資料</h2>
            </header>
            <div class="panel-body" align="right">
              <a href="#" @click.prevent="syncStuData" class="btn-upload btn btn-primary" style="background-color:#e50012; border-color:#d2322d;" align="right">同步資料</a>
              <div class="panel-body">
                <table class="table table-no-more table-bordered table-striped mb-none table-cell-center">
                  <thead>
                    <tr>
                      <th class="text-center" width="4%">修改</th>
                      <th class="text-center" width="10%">系科年級</th>
                      <th class="text-center" width="8%">學號</th>
                      <th class="text-center" width="8%">姓名</th>
                      <th class="text-center" width="10%">身分證編號</th>
                      <th class="text-center" width="12%">縣市鄉鎮區村里</th>
                      <th class="text-center" width="8%">入學日期</th>
                      <th class="text-center" width="8%">在學狀態</th>
                      <th class="text-center" width="8%">兵役狀況</th>
                      <th class="text-center" width="8%">申請項目</th>
                      <th class="text-center" width="8%">狀態</th>
                      <th class="text-center" width="8%">審核狀態</th>
                    </tr>
                  </thead>
                  <tbody >
                    <tr v-for="(item, index) in milltaryList" :key="index">
                      <td class="text-center" data-title="修改">
                        <button type="button" class="mb-xs mt-xs mr-xs btn-xs btn-info" @click="$router.push(`/military/base/edit/${item.studentId}`)"><i class="fa fa-pencil"></i></button>
                      </td>
                      <td class="text-center" data-title="系科年級">{{item.deptDradeClass}}</td>
                      <td class="text-center" data-title="學號">{{item.studentId}}</td>
                      <td class="text-center" data-title="姓名">{{item.studentName}}</td>
                      <td class="text-center" data-title="身分證編號">{{item.idno}}</td>
                      <td class="text-center" data-title="縣市鄉鎮區村里">{{item.address}}</td>
                      <td class="text-center" data-title="入學日期">{{item.entryYM}}</td>
                      <td class="text-center" data-title="在學狀態">{{`${item.state}${(item.restOrOutType ? "(" + item.restOrOutType + ")" : "")}`}}</td>
                      <td class="text-center" data-title="兵役狀況">{{item.militaryStatus}}</td>
                      <td class="text-center" data-title="申請項目">{{item.militaryApply}}</td>
                      <td class="text-center" data-title="狀態">{{item.militaryApplyStatus}}</td>
                      <td class="text-center" data-title="審核狀態">{{item.strAdminCheck}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="panel-body text-center">
                <pageControl v-bind:page="search.page" v-bind:total="totalPage"></pageControl>
              </div>
            </div>
          </section>
        </form>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      educateSystemList: [],
      deptList: [],
      cityList: [],
      tempAreaList: [],
      areaList: [],
      stuStateList: [],
      milltaryList:[],
      totalPage:0,
      search: {
        page:1,
        educateSystem: "",
        dept: "",
        drade: "",
        studentId: "",
        cityId: null,
        areaId: "",
        studentName: "",
        idno: "",
        entryYM: "",
        state: "",
        restOrOutType: "",
        restOrOutDateBegin: null,
        restOrOutDateEnd: null,
        status: "",
        applyItem: "",
        applyStatus: "",
        adminCheck: ""
      },
      qryParam:{}
    };
  },
  mounted() {
    this.$http.get("/api/shared/educate-system-list").then((a) => {
      this.educateSystemList = a.body;
    });
    this.$http.get("/api/shared/dept-list").then((a) => {
      this.deptList = a.body;
    });
    this.$http.get("/api/shared/city-list").then((a) => {
      this.cityList = a.body;
    });
    this.$http.get("/api/shared/area-list").then((a) => {
      this.tempAreaList = a.body;
    });
    this.$http.get("/api/shared/stu-state-list").then((a) => {
      this.stuStateList = a.body;
    });
    if(this.getStore(this.$route.name)){
      this.search = JSON.parse(this.getStore(this.$route.name))
    }
    this.load();
  },
  methods: {
    cityChange() {
      if (this.search.cityId) {
        this.areaList = this.tempAreaList.filter((item) => {
          return item.cityId == this.search.cityId;
        });
      } else {
        this.areaList = [];
      }
      this.search.areaId = null;
    },
    searchSubmit() {
      this.updateGrid(1);
    },
    searchClear() {
      this.search.page = 1;
      this.search.educateSystem = "";
      this.search.dept = "";
      this.search.drade = "";
      this.search.studentId = "";
      this.search.cityId = null;
      this.search.areaId = "";
      this.search.studentName = "";
      this.search.idno = "";
      this.search.entryYM = "";
      this.search.state = "";
      this.search.restOrOutType = "";
      this.search.restOrOutDateBegin = null;
      this.search.restOrOutDateEnd = null;
      this.search.status = "";
      this.search.applyItem = "";
      this.search.applyStatus = "";
      this.search.adminCheck = "";
      // this.$root.militaryBaseSearch = this.search;
      this.load();
    },
    updateGrid(page){
			this.search.page = page;
			this.load();
		},
    load() {
      let vm = this;
      // if ($.fn.DataTable.isDataTable(vm.$refs.table)) {
      //   $(vm.$refs.table).DataTable().destroy();
      // }
      // let d = vm.search.restOrOutDate;
      // let restOrOutDate = "";
      // if (d)
      //   restOrOutDate =
      //     d.getFullYear() + "/" + (d.getMonth() + 1) + "/" + d.getDay();

      this.qryParam = {
            page:this.search.page,
            pageSize:10,
            educateSystem: this.search.educateSystem,
            dept: vm.search.dept,
            drade: vm.search.drade,
            studentId: vm.search.studentId.trim(),
            cityId: vm.search.cityId ? parseInt(vm.search.cityId) : null,
            areaId: vm.search.areaId,
            studentName: vm.search.studentName.trim(),
            idno: vm.search.idno.trim(),
            entryYM: vm.search.entryYM.trim(),
            state: vm.search.state,
            restOrOutType: vm.search.restOrOutType,
            restOrOutDateBegin: vm.search.restOrOutDateBegin ? vm.customFormatter(vm.search.restOrOutDateBegin): null,
            restOrOutDateEnd: vm.search.restOrOutDateEnd ? vm.customFormatter(vm.search.restOrOutDateEnd): null,
            status: vm.search.status,
            applyItem: vm.search.applyItem,
            applyStatus: vm.search.applyStatus,
            adminCheck: vm.search.adminCheck,
      };
      vm.$http
        .get("/api/military", {
          params: this.qryParam,
        }).then((a) => {
          vm.milltaryList = a.body.rows;
          vm.totalPage = a.body.total;
          vm.page = a.body.page;
        });
      // $("table.table tbody").on("click", "button[data-edit]", function () {
      //   let id = $(this).data("edit");
      //   vm.$router.push("/military/base/edit/" + id);
      // });
    },
    searchExport() {
      this.$http
        .post(
          "/api/militaryExport/total?educateSystem=" +
            this.search.educateSystem +
            "&dept=" +
            this.search.dept +
            "&drade=" +
            this.search.drade +
            "&studentId=" +
            this.search.studentId.trim() +
            "&cityId=" +
            (this.search.cityId ? this.search.cityId : "") +
            "&areaId=" +
            this.search.areaId +
            "&studentName=" +
            this.search.studentName.trim() +
            "&idno=" +
            this.search.idno.trim() +
            "&entryYM=" +
            this.search.entryYM.trim() +
            "&state=" +
            this.search.state +
            "&restOrOutType=" +
            this.search.restOrOutType +
            "&restOrOutDateBegin=" +
            (this.search.restOrOutDateBegin? this.customFormatter(this.search.restOrOutDateBegin) :"")+
            "&restOrOutDateEnd=" +
            (this.search.restOrOutDateEnd ? this.customFormatter(this.search.restOrOutDateEnd) : "")+
            "&status=" +
            this.search.status +
            "&applyItem=" +
            this.search.applyItem +
            "&applyStatus=" +
            this.search.applyStatus +
            "&adminCheck=" +
            this.search.adminCheck,
          {},
          { responseType: "arraybuffer" }
        )
        .then((res) => {
          this.download2File(res);
        });
    },
    syncStuData() {
      this.$http.get("/api/index/SyncUserData").then((a) => {
        alert("資料已同步完成");
        this.load();
      });
    },
  },
  async beforeRouteLeave(to, from, next) {
    console.log(to.name);
    if(to.name == "/military/base/edit/:id"){
      window.sessionStorage.setItem(this.$route.name,JSON.stringify(this.qryParam));
      await this.$http.get(`/api/military/stdList`, {
        params: this.qryParam,
      }).then(a => {
        window.sessionStorage.setItem("militaryBaseStuIdList",JSON.stringify(a.body));
      });
    }else{
      this.removeStore(this.$route.name);
      this.removeStore("militaryBaseStuIdList");
    }
		next();
	}
};
</script>

<style>
table.table-cell-center td {
  text-align: center;
}
</style>